import { Controller } from "@hotwired/stimulus"
import Holder from "holderjs";

export default class extends Controller {
  static targets = ["entries", "pagination","scrollDownIndicator"]

  scroll(){
    if ( this.scrolledToBottom() ) {
      let next_page = this.paginationTarget.querySelector("a[rel='next']")
      if ( next_page == null ) {
        if(this.data.get("loadInProgress")!="true"){
          this.hidePagination()
        }
        return
      }

      let url = next_page.href

      this.loadMore(url)
    }
  }

  loadMore(url){
    if(this.data.get("loadInProgress")=="true"){
      return Promise.resolve()
    }
    this.data.set("loadInProgress","true")
    this.showLoadingIndicator()

    return fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin"
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then((data) => {
        this.entriesTarget.insertAdjacentHTML("beforeend", data.entries)
        this.paginationTarget.innerHTML = data.pagination
        Holder.run()
        return true
      })
      .catch((error) => {
        console.error("[infinite-scroll] Unable to load more entries", error)
        this.hidePagination()
        return false
      })
      .finally(() => {
        this.data.set("loadInProgress","false")
      })
  }

  scrolledToBottom() {
    var body = document.body,
        html = document.documentElement

    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)

    var anticipation = $("footer").outerHeight()+285 // 285 es la altura de 1 post

    return (window.pageYOffset >= height - window.innerHeight - anticipation)
  }

  showLoadingIndicator(){
    this.paginationTarget.innerHTML = this.data.get("loadingMessage")
  }

  hidePagination(){
    this.paginationTarget.style="display:none"
    if(this.hasScrollDownIndicatorTarget){
      this.scrollDownIndicatorTarget.style="display:none"
    }
  }

}
